import { Badge } from '@rematter/ui-web';

import { useTranslations } from '../../i18n/useTranslations';

type CountTaskStatusBadgeProps = {
  status: string;
};

const STATUS_BADGE_COLOR: Record<
  string,
  'neutral' | 'primary' | 'success' | 'warning' | 'failure'
> = {
  Pending: 'neutral',
  InProgress: 'primary',
  Completed: 'warning',
  Approved: 'success',
  Cancelled: 'failure',
};

export const CountTaskStatusBadge = ({ status }: CountTaskStatusBadgeProps) => {
  const t = useTranslations();

  return (
    <Badge
      color={STATUS_BADGE_COLOR[status] ?? 'neutral'}
      className="@CountTaskStatusBadge"
    >
      {t.cycleCountTasksView.statusTypes[status] ?? status}
    </Badge>
  );
};
